import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "skeleton"]

  connect() {
    this.element.addEventListener("turbo:before-fetch-request", (event) => {
      // Only show skeleton if the request is coming from within this element (the frame)
      if (this.element.contains(event.target)) {
        this.showSkeleton()
      }
    })
    
    this.element.addEventListener("turbo:frame-render", () => {
      this.hideSkeleton()
    })
  }

  showSkeleton() {
    if (this.hasSkeletonTarget && this.hasContentTarget) {
      this.contentTarget.classList.add("hidden")
      this.skeletonTarget.classList.remove("hidden")
    }
  }

  hideSkeleton() {
    if (this.hasSkeletonTarget && this.hasContentTarget) {
      this.skeletonTarget.classList.add("hidden")
      this.contentTarget.classList.remove("hidden")
    }
  }
}
